import {useState} from "react";

export const useModalClients = () => {

  const [visibleModalRestore, setVisibleModalRestore] = useState<boolean>(false);
  const [visibleModalDelete, setVisibleModalDelete] = useState<boolean>(false);
  const [visibleModalPortalClient, setVisibleModalPortalClient] = useState<boolean>(false);
  const [visibleModalExport, setVisibleModalExport] = useState<boolean>(false);


  return {
    visibleModalRestore, setVisibleModalRestore,
    visibleModalDelete, setVisibleModalDelete,
    visibleModalPortalClient, setVisibleModalPortalClient,
    visibleModalExport, setVisibleModalExport

  }
}
